import { PropsWithChildren, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export function AxiosInterceptor({ children }: PropsWithChildren) {
    const navigate = useNavigate();

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            response => response,
            error => {
                const errorCode = error.response?.data?.code;
                // Expected lesson restrictions belong to the lesson dialog on the current page.
                if (error.response?.status === 403 && errorCode !== 'module_prerequisites_not_met') {
                    const isAlreadyOnForbidden = window.location.pathname === '/403';
                    if (!isAlreadyOnForbidden) {
                        navigate('/403', {
                            state: { reason: errorCode === 'USER_LOCKED' ? 'locked' : 'unauthorized' },
                            replace: true
                        });
                        return new Promise(() => {});
                    }
                }
                return Promise.reject(error);
            }
        );
        return () => axios.interceptors.response.eject(interceptor);
    }, [navigate]);

    return <>{children}</>;
}
